import React from "react";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { LanguageContext } from "./i18n/context";

const AlertDismissible = ({
  showInstructions,
  setShowInstructions,
  config,
}) => {
  return (
    <LanguageContext.Consumer>
      {({ language, changeLanguage }) => (
        <Alert
          style={{ opacity: 100 }}
          variant="primary"
          show={showInstructions}
        >
          <Alert.Heading>
            {language === "PL" ? config.title : "Instructions"}
          </Alert.Heading>
          <p>
            {language === "PL"
              ? config.content
              : "Click one of the displayed poster's thumbnails to see the poster. You can use the search bar to search the poster. While in poster view, you can use navigation buttons to change the poster's page. Use buttons below the poster's title to navigate to next/previous poster."}
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setShowInstructions(false);
                localStorage.setItem("posters-instructions", false);
              }}
              variant="outline-primary"
            >
              {language === "PL" ? config.button : "Don't display"}
            </Button>
          </div>
        </Alert>
      )}
    </LanguageContext.Consumer>
  );
};

export default AlertDismissible;
